import React from "react";
import { useField } from "formik";
import { Textarea } from "@jsq/ds/core";
import { PaymentDetailsStepInputFields } from "./schema";

export const MakerNoteTextarea: React.FC = () => {
  const [field, meta] = useField(PaymentDetailsStepInputFields.MakerNote);
  const currentLength = (field.value as string)?.length || 0;
  const remainingChars = 250 - currentLength;

  return (
    <Textarea
      {...field}
      label="Notes for reviewer"
      isFullWidth
      size="small"
      maxLength={250}
      helpText={`${remainingChars <= 0 ? 0 : remainingChars} characters remaining`}
      errorMessage={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
